import React from 'react';
import flectionNumeral from '../../../helpers/number';

import './number-of-offer.scss';

interface NumberOfOffersProps {
    count: number;
    items: {
        id: number;
        dealer: {
            id: number;
            name: string;
        };
    }[];
}

const NumberOfOffer: React.FC<{ offers: NumberOfOffersProps; }> = ({ offers }) => {
    if (offers.count) {
        let text = '';

        if (offers.count === 1 && offers.items.length && offers.items?.[0]?.dealer?.name) {
            text = offers.items[0].dealer.name;
        } else {
            text = flectionNumeral(offers.count, ['oferta sklepu', 'oferty sklepów', 'ofert sklepów']);
        }

        return (
            <span className="number-of-offer">
                {text}
            </span>
        );
    }

    return null;
};

export default NumberOfOffer;
